import * as dashboardTypes from './dashboardTypes';

const initialState = {
  headerCount: null,
  engagements: [],
  casePhases: {},
  selectedMessageId: null,
  selectedEngagement: null,
  favoriteTableData: {},
  recentCasesTableData:{},
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case dashboardTypes.FETCH_DASHBOARD_HEADER_COUNTS_SUCCESS: {
      return {
        ...state,
        headerCount: action.data,
      };
    }
    case dashboardTypes.GET_ENGAGEMENTS_SUCCESS: {
      return {
        ...state,
        engagements: action.res,
      };
    }
    case dashboardTypes.STORE_SELECTED_MESSAGE_ID: {
      return {
        ...state,
        selectedMessageId: action.id,
      };
    }
    case dashboardTypes.GET_CASE_PHASES_SUCCESS: {
      return { ...state, casePhases: action.data };
    }
    case dashboardTypes.STORE_SELECTED_ENGAGEMENT: {
      return { ...state, selectedEngagement: action.payload.engagement };
    }
    case dashboardTypes.RESET_SELECTED_MESSAGE_ID: {
      return { ...state, selectedMessageId: null };
    }
    case dashboardTypes.SET_DASHBORD_CASE_UPDATE: {
      let caseFavoriteNew = state.favoriteTableData.cases.slice();
      caseFavoriteNew[action.payload].isFavorite = action.isChecked;
      return {
        ...state,
        favoriteTableData: { ...state.favoriteTableData, cases: caseFavoriteNew },
      };
    }
    case dashboardTypes.GET_FAVORITE_CASE: {
      return { ...state, favoriteTableData: action.payload };
    }
    case dashboardTypes.GET_RECENT_CASE: {
      return { ...state, recentCasesTableData: action.payload };
    }
    case dashboardTypes.GET_RECENT_CASE_FAILED: {
      return { ...state, recentCasesTableData: {} };
    }
    default: {
      return state;
    }
  }
};

export default dashboardReducer;
